// Some aliases to make objects non-reactive so Vue doesn't setup observers on
// any of the objects.
//
// While the underlying functions are simple, we're just wrapping them so the
// calling code is more clear in its intention.
//
// See:
// https://github.com/vuejs/vuejs.org/issues/978
// https://github.com/vuejs/vue/issues/2637
export default {
  // Use Object.freeze to mark objects as non-reactive.
  //
  // This is useful for our ajax results containing station details. These
  // arrays can be large (particularly for list of stations for the base map),
  // and since the data will be replaced in its entirety (by new ajax calls),
  // rather than being modified in place, we can see significant performance
  // benefits by freezing the objects to prevent Vue from making the data
  // reactive (freezing also helps ensure we don't accidentally modify this
  // read-only data).
  frozen(obj) {
    return Object.freeze(obj);
  },

  // Use Object.defineProperty with "configurable: false" to ensure Vue won't
  // make a specific property reactive without completely freezing it.
  //
  // See https://github.com/vuejs/vue/issues/2637#issuecomment-361633222
  unfrozen(obj, prop) {
    Object.defineProperty(obj, prop, { configurable: false });
  },
};
